<header #header [ngClass]="{'guest': !isAuthorized, 'collapsed': !isExpanded && isAuthorized }">
  @if (!isAuthorized) {
    <img class="logo" [ngClass]="{'inverted': invertedLoginColor}" />
  } @else {
    <!-- toolbar only visible on mobile devices. -->
    <mat-toolbar class="hidden-d-none" [hidden]="!isMobileScreen" [attr.aria-hidden]="!isMobileScreen">
      <button id="navToggleBtn" type="button" class="menu-toggle" (click)="toggleMobileNav($event)" aria-controls="nav-menu" [attr.aria-expanded]="openNavMenu" aria-label="Open main navigation">
        <mat-icon>menu</mat-icon>
      </button>
      <div [hidden]="( !isExpanded )" class="logo-wrapper hidden-d-none" role="presentation">
        <p class="mat-headline">Admin</p>
      </div>
    </mat-toolbar>
    <navigation #mainNav
      (toggleDesktopNav)="notifyDesktopNavToggleClick($event)"
      (toggleMobileNav)="toggleMobileNav($event)"
      (closeSecondaryNav)="closeSecondaryNav()"
      [isExpanded]="isExpanded"
      [isMobileScreen]="isMobileScreen"
      [isMobileNavOpen]="openNavMenu"
      [@.disabled]="disableAnimations"
      [@openClose]="!openNavMenu && isMobileScreen ? 'closed' : 'open'"
      [attr.aria-hidden]="!openNavMenu && isMobileScreen"
      [activeSecondaryNavUrl]="activeSecondaryNavUrl">
    </navigation>
    <account-settings-menu [ngClass]="{'collapsed': !isExpanded && !isMobileScreen}" [isExpanded]="isExpanded" [isMobileScreen]="isMobileScreen"></account-settings-menu>
  }
</header>
